<script>
	import Router from 'svelte-spa-router'
	import { push } from 'svelte-spa-router'
	import mainRoutes from './routes.js'
	import { addMessages, init , locale } from "svelte-i18n";

	const activeLink = '';;

	let routes;

	import he from "./locales/he.json";
	
	addMessages("he", he);
	
	init({
		initialLocale: "he",
	});	

	routes = mainRoutes;


	
</script>

<main>
	<Router {routes}/>
</main>